import { Box, IconButton, SxProps, TextField } from "@mui/material"
import { IconSendMessage } from "../../../icons/IconSendMessage"
import { BoxIconStyle, TextfieldStyle } from "./style"
import { forwardRef } from "react"

type CommentInputProps = {
  sx?: SxProps
  value?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  name?: string
  onSend?: () => void
  disabled?: boolean
}

export const CommentInput = forwardRef<HTMLInputElement, CommentInputProps>(({sx, value, onChange, name, onSend, disabled}, ref) => {
  return (
    <TextField
      inputRef={ref}
      multiline
      fullWidth
      placeholder="Введите ваш вопрос…"
      minRows={1}
      sx={sx}
      value={value}          
      onChange={onChange}    
      name={name}  
      InputProps={{
        endAdornment: (
          <Box sx={BoxIconStyle}>
            <IconButton onClick={onSend} disabled={disabled}>
              <IconSendMessage />
            </IconButton>
          </Box>
        ),
        sx: TextfieldStyle,
      }}
    />
  )
})
